"use client";

import {
  Alert,
  AlertTitle,
  Backdrop,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import CustomAccordion from "./Ui/CustomAccordion";
import Face6Icon from "@mui/icons-material/Face6";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import ListIcon from "@mui/icons-material/List";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import HandshakeIcon from "@mui/icons-material/Handshake";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import { useEffect, useState } from "react";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
import { useBusinessContext } from "../../context/business-context";
// import CustomAccordion from "./custom-accordion";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onGetactivationList?: () => void;
  branches: any[];
  roles: any[];
  selectedStaff?: any;
  banklist?: any[];
};

export default function StaffModal({
  isOpen,
  onClose,
  roles,
  branches,
  banklist = [],
  onGetactivationList,
  selectedStaff,
}: Props) {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [sex, setSex] = useState("");
  const [role, setRole] = useState("");
  const [branch, setBranch] = useState("");
console.log({banklist})
 
  const [accountNumber, setAccountNumber] = useState("");
  const [bankName, setBankName] = useState(""); // Added
  const [accountName, setAccountName] = useState(""); // Added
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");

  const { selectedBusinessId } = useBusinessContext();

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const onAddStaff = async () => {
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusinessId);
      formData.append("branch_id", branch);
      formData.append('first_name',firstName);
      formData.append('last_name',lastName);
      formData.append('middle_name',middleName);
      formData.append("email", email);
      formData.append("phone", phoneNumber);
      formData.append("password", password);
      formData.append("roleID", role);
      formData.append("accountNumber", accountNumber);
      formData.append("bankCode", bankCode);
      formData.append("accountName", accountName);


      if(selectedStaff){
        formData.append("user_id", selectedStaff.user_id)
      };
      const url = !selectedStaff ? "staffs/addStaff" : "staffs/editStaff";

      const response = await axios.post(
        baseUrl() + url,
        formData,
        config
      );
      console.log(response);
      const data = await response.data;
      if(data.status == "false"){
        setIsError(true);
        setStatus({ loading: false, error: true });
        setAlertMsg(data.message || "An error occurred.");
        onShowAlert();

      }

   
      setAlertMsg(data.message || "Code generated successfully.");
      onShowAlert();
      setStatus({ loading: false, error: false });
      onClose();
      setEmail("");
      setBranch("");
      setRole("");
        onGetactivationList()
        
    } catch (error) {
      setStatus({ loading: false, error: true });
      console.log(error);
      setIsError(true);
      setAlertMsg(error?.response.data.message || "An error occurred.");
      onShowAlert();
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  useEffect(() => {
    if (selectedStaff) {
      setFirstName(selectedStaff.firstName);
      setMiddleName(selectedStaff.middleName);
      setLastName(selectedStaff.lastName);
      setEmail(selectedStaff.email);
      setPhoneNumber(selectedStaff.phone);
      setBranch(selectedStaff.branch_id)
      setRole(selectedStaff.roleID)
    }else{
      setFirstName("");
      setMiddleName("");
      setLastName("");
      setEmail("");
      setPhoneNumber("");
    }
  }, [selectedStaff]);

   const [bankCode, setBankCode] = useState("");
     const getAccountName = async (id) => {
      // try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
         formData.append("accountNumber", id);
      formData.append("bankCode", bankCode);

     // console.log(formData);
      const response = await axios.post(
        baseUrl() + "warehouses/getAccountName",
        formData,
        config
      );
    //  console.log( response );
     // const data = await response.data.data;
      setAccountName(response.data.data);
      setStatus({ loading: false, error: false });
    };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: 600,
          width: 900,
          bgcolor: "white",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          {selectedStaff ? "Edit Staff" : "Add Staff"}
        </Typography>

        {showAlert && (
          <Alert severity={isError ? "error" : "success"}>
            <AlertTitle>{isError ? "Error " : "Success"}</AlertTitle>
            {alertMsg?.toUpperCase()}  {isError}
          </Alert>
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            "& > :not(style)": { m: 1 },
          }}
        >
          <TextField
            fullWidth
            label="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <TextField
            fullWidth
            label="Middle Name"
            value={middleName}
            onChange={(e) => setMiddleName(e.target.value)}
          />
        </Box>     <Box
          sx={{
            display: "flex",
            alignItems: "center",
            "& > :not(style)": { m: 1 },
          }}
        >
         {/*  <TextField
            fullWidth
            label="Bank Account Name"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
          />
 */}
          
           {/* <FormControl fullWidth sx={{ mt: 2 }}>
  <InputLabel>Bank List</InputLabel>
  <Select
    value={bankCode}
    label="Select Bank"
    onChange={(e) => setBankCode(e.target.value)}
  >
    {banklist
      .map((banklist, index) => (
        <MenuItem key={index} value={banklist.code}>
          {banklist.name.toUpperCase()} 
        </MenuItem>
      ))}
  </Select>
</FormControl>

<TextField
  fullWidth
  label="Account Number"
  value={accountNumber}
  onInput={(e) => {
    const value = e.target.value;
    setAccountNumber(value);

    if (value.length > 9) {
      getAccountName(e.target.value); // Call only when length is 10
    }
  }}
/> */}


        </Box>
{/* <Box
  sx={{
    display: "flex",
    alignItems: "center",
    my: 1, // standard vertical spacing (top and bottom)
        ml: 2,  // left margin

    "& > :not(style)": {
      mr: 5,
    },
  }}
>
  Account Name: {accountName}
</Box> */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            "& > :not(style)": { m: 1 },
          }}
        >
          <TextField
            fullWidth
            label="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <TextField
            fullWidth
            label="Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />


        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            "& > :not(style)": { m: 1 },
          }}
        >
          <TextField
            fullWidth
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            fullWidth
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            "& > :not(style)": { m: 1 },
          }}
        >
        <FormControl fullWidth sx={{ mt: 2 }}>
  <InputLabel>Role</InputLabel>
  <Select
    value={role}
    label="Select Role"
    onChange={(e) => setRole(e.target.value)}
  >
    {roles
      ?.filter((role) => role.roleID != 12222) 
.map((role, index) => (
        <MenuItem key={index} value={role.roleID}>
          {role.name.toUpperCase()} 
        </MenuItem>
      ))}
  </Select>
</FormControl>


          <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Branch</InputLabel>
          <Select
            value={branch}
            label="Branch"
            onChange={(e) => setBranch(e.target.value)}
          >
            {branches?.map((branchOption, index) => (
              <MenuItem key={index} value={branchOption.branch_id}>
                {branchOption.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
</Box>


        {/* Submit Button */}
        <Button
          variant="contained"
          sx={{ mt: 4 }}
          onClick={onAddStaff}
          disabled={!email || !firstName}
        >
          {status.loading ? "Loading..." : "Submit"}
        </Button>

        {/* Close Button */}
        <Button disabled={status.loading} variant="outlined" sx={{ mt: 4, ml: 2 }} onClick={onClose}>
          Close
        </Button>
      </Box>
    </Modal>
  );
}

